import { useTranslation } from 'react-i18next';

import PersonIcon from '@mui/icons-material/Person';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Divider, IconButton, Modal, Typography, useTheme } from '@mui/material';

import { StandardSmallModalBox } from '@frontend/features/common/utils/modals';

import { useGetTeamById } from '../../queries';
import { Form } from './Form';

interface EditTeamModalProps {
  open: boolean;
  onClose: () => void;
  id?: number;
  agencyId: string;
}

export const EditTeamModal = ({ open, onClose, id, agencyId }: EditTeamModalProps) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const { data } = useGetTeamById({
    id,
  });

  return (
    <Modal open={open} onClose={onClose} aria-labelledby={t('teams.edit.title')}>
      <StandardSmallModalBox display="flex" flexDirection="column" gap={theme.spacing(2)}>
        <Box display="flex" gap={theme.spacing(2)}>
          <Box flexGrow={1} display="flex" alignItems="center" gap={theme.spacing(1)}>
            <PersonIcon color="disabled" />
            <Typography id="create-agency-modal-title" variant="h6" component="h2">
              {t('teams.edit.title')}
            </Typography>
          </Box>
          <IconButton onClick={onClose}>
            <CloseIcon color="primary" />
          </IconButton>
        </Box>
        <Divider />
        <Form agencyId={agencyId} onClose={onClose} data={data} />
      </StandardSmallModalBox>
    </Modal>
  );
};
